import Input from '@components/common/forms/input'
import { QUIZ_USERNAME_LOCAL_STORAGE_KEY } from '@lib/constants/quizzes'
import { setToLocalStorage } from '@lib/utils/local-storage'
import * as Sentry from '@sentry/node'
import { FormEvent, useState } from 'react'

type Props = {
  setNextStep: () => void
}

const UsernameForm = ({ setNextStep }: Props) => {
  const [username, setUsername] = useState('')

  const handleOnSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setToLocalStorage(QUIZ_USERNAME_LOCAL_STORAGE_KEY, username, () =>
      Sentry.captureMessage(
        `Failed to store to local storage. Key: ${QUIZ_USERNAME_LOCAL_STORAGE_KEY}`
      )
    )
    setNextStep()
  }

  return (
    <div className="h-screen flex items-center justify-center">
      <form
        className="flex flex-col bg-white rounded-lg p-6 w-80 lg:w-108 lg:p-10"
        onSubmit={handleOnSubmit}
      >
        <p className="text-grey font-600">Your quiz name is...</p>
        <Input
          id="username-input"
          name="username"
          onChange={(e) => setUsername(e.currentTarget.value)}
        />
        <button type="submit" className="btn btn-orange">
          Start
        </button>
      </form>
    </div>
  )
}

export default UsernameForm
